import {ObjectDTO} from './object-dto';

export class TypeTacheDTO extends ObjectDTO {

  code: string;
  libelle: string;
  actif: boolean;

}
